import React, {useState} from 'react';
import {TextField} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import {useTranslation} from "react-i18next";

interface TableSearchProps {
  onSearch: (searchTerm: string) => void;
}

export default function TableSearch({onSearch}: Readonly<TableSearchProps>) {
  const [searchTerm, setSearchTerm] = useState('');

  const {t} = useTranslation()

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <TextField
      id="search"
      label={t('pages.tableSearch')}
      variant="standard"
      value={searchTerm}
      onChange={handleSearch}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon/>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
